import React from 'react'
import useBranding from '../useBranding'

function rp(n) { return 'Rp ' + Number(n || 0).toLocaleString('id-ID') }
function periodeLabel(periode) {
  const [tahun, bulan] = periode.split('-')
  return new Date(Number(tahun), Number(bulan) - 1, 1).toLocaleDateString('id-ID', { month: 'long', year: 'numeric' })
}
function namaHariTanggal(tanggal) {
  return new Date(tanggal + 'T00:00:00').toLocaleDateString('id-ID', { weekday: 'short', day: '2-digit', month: 'short' })
}

// Markup dokumen slip gaji -- dipakai DUA tempat: pratinjau di modal Payroll.jsx (layar saja) dan
// halaman cetak standalone PayrollSlipCetak.jsx (tab bersih tanpa sidebar/modal, dipakai window.print()
// yg sesungguhnya). Diekstrak ke sini 2026-07-22 supaya kedua tempat itu tidak duplikasi markup --
// sebelumnya cetak pakai trik CSS "sembunyikan elemen lain" dari dalam modal, ternyata rapuh lintas
// browser (user lapor hasil cetak cuma nongol Jurnal Pekerjaan doang, elemen lain hilang) -- pindah
// ke tab terpisah yg ISINYA MEMANG CUMA slip ini jauh lebih andal krn tidak ada apa pun lain yg perlu
// disembunyikan.
export default function SlipDoc({ slip }) {
  const businessName = useBranding()
  return (
    <div className="slip-doc">
      <div className="slip-doc-header">
        <div className="company">{businessName.toUpperCase()}</div>
        <div className="doctitle">Slip Gaji Karyawan — Periode {periodeLabel(slip.periode)}</div>
      </div>

      <div className="slip-doc-meta">
        <div className="row"><span className="label">Nama</span><span><strong>{slip.nama}</strong></span></div>
        <div className="row"><span className="label">Bank</span><span>{slip.nama_bank || '-'}{slip.no_rekening ? ` — ${slip.no_rekening}` : ''}</span></div>
        <div className="row"><span className="label">Jabatan</span><span>{slip.jabatan || '-'}</span></div>
        <div className="row"><span className="label">Dibuat</span><span>{slip.dibuat_oleh || '-'}</span></div>
      </div>

      <table className="slip-table">
        <thead><tr><th>Pendapatan</th><th style={{ textAlign: 'right' }}>Jumlah</th></tr></thead>
        <tbody>
          <tr><td>Gaji Pokok</td><td className="amount">{rp(slip.gaji_pokok)}</td></tr>
          <tr><td>Makan &amp; Transport</td><td className="amount">{rp(slip.uang_makan_transport)}</td></tr>
          <tr><td>Bonus</td><td className="amount">{rp(slip.bonus)}</td></tr>
          {slip.bonus_jenis_pekerjaan > 0 && <tr><td>Bonus Jenis Pekerjaan</td><td className="amount">{rp(slip.bonus_jenis_pekerjaan)}</td></tr>}
        </tbody>
      </table>

      <table className="slip-table">
        <thead><tr><th>Potongan</th><th style={{ textAlign: 'right' }}>Jumlah</th></tr></thead>
        <tbody>
          <tr><td>BPJS</td><td className="amount">-{rp(slip.potongan_bpjs)}</td></tr>
          <tr><td>Cicilan Kasbon{slip.potongan_kasbon > 0 ? ` (saldo ${rp(slip.kasbon_saldo_sebelum)} → sisa ${rp(slip.kasbon_saldo_sesudah)})` : ''}</td><td className="amount">-{rp(slip.potongan_kasbon)}</td></tr>
          {slip.potongan_lain > 0 && <tr><td>Lain-lain{slip.catatan_potongan_lain ? ` (${slip.catatan_potongan_lain})` : ''}</td><td className="amount">-{rp(slip.potongan_lain)}</td></tr>}
        </tbody>
      </table>

      <div className="slip-total">
        <span>Total Diterima</span><span>{rp(slip.total_diterima)}</span>
      </div>

      {slip.jurnal && (
        <>
          <div className="jurnal-title">Jurnal Pekerjaan — {periodeLabel(slip.periode)}</div>
          <table className="jurnal-table">
            <thead><tr><th>Tanggal</th><th>Aktivitas</th></tr></thead>
            <tbody>
              {slip.jurnal.map(h => (
                <tr key={h.tanggal} className={h.kosong ? 'kosong' : ''}>
                  <td className="tgl">{namaHariTanggal(h.tanggal)}</td>
                  <td>
                    {h.items.length > 0
                      ? h.items.map((it, i) => <div key={i}>{it.jenis}{it.lokasi ? ` — ${it.lokasi}` : ''} ({it.status})</div>)
                      : (h.kosong ? 'Tidak ada aktivitas tercatat' : '-')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      <div className="slip-signature">
        <div>
          <div>Mengetahui,</div>
          <div className="line">Admin</div>
        </div>
        <div>
          <div>Diterima oleh,</div>
          <div className="line">{slip.nama}</div>
        </div>
      </div>
    </div>
  )
}
